import queryString from 'query-string';
import _ from 'underscore';

import { EmailMeFallbackLocale } from './constants';

export const getLocationSearch = () => window.location.search;

// query-string returns an array when a param is duplicated in the URL; these params are
// single-valued, so normalize any array to its first entry to avoid string-method crashes.
const firstValue = value => (Array.isArray(value) ? value[0] : value);

export const extractSourceId = (locationHref = window.location.href) => {
  const options = queryString.parseUrl(locationHref, { parseFragmentIdentifier: true });
  const scid = firstValue(options.query.s_cid);
  return scid || '';
};

export const extractMkt = (locationHref = window.location.href) => {
  const options = queryString.parseUrl(locationHref, { parseFragmentIdentifier: true });
  const mkt = firstValue(options.query.mkt);
  return mkt || '';
};

export const fallbackMkt = (mkt) => {
  if (mkt && _.has(EmailMeFallbackLocale, mkt)) {
    return _.get(EmailMeFallbackLocale, mkt);
  }

  return mkt;
};

export const extractWebsite = (locationHref = window.location.href) => {
  const options = queryString.parseUrl(locationHref, { parseFragmentIdentifier: true });
  const finalUrl = firstValue(options.query.finalUrl);
  return finalUrl || '';
};

export const extractCacheRelatedId = (locationHref = window.location.href) => {
  const options = queryString.parseUrl(locationHref, { parseFragmentIdentifier: true, decode: false });
  const { cacheId = '', email = '', signature = '' } = options.query;
  return {
    cacheId: firstValue(cacheId),
    email: firstValue(email),
    signature: firstValue(signature),
  };
};

export const appendCacheId = (url, cacheId) => {
  if (!cacheId || !url) {
    return url;
  }
  const options = queryString.parseUrl(url, { parseFragmentIdentifier: true });
  options.query.cacheId = cacheId;
  return queryString.stringifyUrl(options, { encode: false });
};

export const getLandingPageUrl = (locationHref = window.location.href) => {
  const options = queryString.parseUrl(locationHref, { parseFragmentIdentifier: true });
  options.query.isSDK = undefined;

  return queryString.stringifyUrl(options, { encode: false });
};

export const removeQueryParam = (paramName, url = window.location.href) => {
  if (!paramName) {
    return url;
  }

  const options = queryString.parseUrl(url, { parseFragmentIdentifier: true });
  options.query[paramName] = undefined; // Setting to undefined will remove it during stringification

  return queryString.stringifyUrl(options, { encode: false });
};
